<!-- 项目重构   选品中心 -->
<template>
    <div class="mlk-box">
        <PcHeader></PcHeader>
        <div class="mlk-box-inner" ref="inner">
            <div class="ul-box" ref="ulBox">
                <ul class="ul_top">
                    <p class="hr">{{ $t('navbar.SelAndCat') }}</p>
                    <div v-for="(item, index) in selectionList" :key="index" :class="[index == active ? 'fabric_warpActive' : 'fabric_warp']">
                        <li :class="[index == active ? 'active' : 'fabric_box']" @click="changeActive(index, item),
                        dialogFormVisible = !dialogFormVisible, changeIndex(index),isChoose(index, item)">
                            <img v-if="item.categoryName=='面料'" src="../../../assets/icons/fabric.png" alt="" class="fabric_icon">
                            <img v-if="item.categoryName=='选品中心'" src="../../../assets/icons/selection.png" alt="" class="fabric_icon">
                            <span>{{datalang == '中文简体' ? item.categoryName : item.categoryNameEn }}</span>
                            <img src="../../../assets/icons/arrow.png" alt="" class="arrow">
                        </li>

                        <div v-show="dialogFormVisible && selectionList[index2].children.length > 0" class="dialog_children">
                            <template>
                                <i class="el-icon-close" @click="close"></i>
                                <el-tree class="my-tree" :data="selectionList[index2].children" show-checkbox default-expand-all node-key="id"
                                    ref="tree" highlight-current :props="datalang == '中文简体' ? defaultProps : defaultPropsEn" :filter-node-method="filterNode" 
                                    check-on-click-node :expand-on-click-node="false" @check-change="checkChange" @check="currentChecked">
                                </el-tree>
                            </template>
                        </div>
                    </div>
                </ul>
                <ul class="ul_search">
                    <div v-for="(item, index) in searchConditionList" :key="index" class="search_list">
                        <p class="hr">{{ datalang == '中文简体' ? item.searchName : item.searchNameEn }}</p>
                        <div v-for="(item2, index2) in item.children" :key="index2" :class="[isActive(index, index2) ? 'search_warpActive' : 'search_warp']">
                            <li :class="[isActive(index, index2) ? 'searchActive' : 'search_box']" @click="changeSearchActive(index,index2,item2),
                            changeSearchIndex(index,index2),isSearchChoose(index2, item2)">
                                <img :src="item2.searchImage" alt="" class="fabric_icon">
                                <span>{{ datalang == '中文简体' ? item2.searchName : item2.searchNameEn }}</span>
                                <img src="../../../assets/icons/arrow.png" alt="" class="arrow">
                            </li>
                            <div v-show="dialogSearchVisible && searchChildren.length > 0" class="dialog_children">
                                <template v-if="datalang == '中文简体'">
                                    <i class="el-icon-close" @click="close"></i>
                                    <el-tree class="my-tree" :data="searchChildren" show-checkbox default-expand-all node-key="id" :check-strictly="true"
                                        :ref="'treess_'+ index + '_' + index2" highlight-current :props="searchDefaultProps" :filter-node-method="filterNode" check-on-click-node 
                                        :expand-on-click-node="true" @check-change="checkChange" @check="currentChecked" @node-click="handleNodeClick">

                                        <div class="custom-tree-node" slot-scope="{ node,data }">
                                            <div class="node_box">
                                                <img v-if="data.searchImage" :src="data.searchImage" alt="" class="node_img">
                                                <span>{{ node.label }}</span>
                                            </div>
                                            <div v-if="data.valueFlag == 1 && isChecked(data.id) && !data.children.length" class="Percentage_box">
                                                <div class="Percentage_input" v-if="data.searchType == 'theWeight' || data.searchType == 'theWidth'">
                                                    <input class="input" type="number" placeholder="0" min="0" v-model="inputBoxes[data.id].inputValue1" @click.stop />
                                                    <span> ~ </span>
                                                    <input class="input" type="number" placeholder="300" min="0" v-model="inputBoxes[data.id].inputValue2" @click.stop />
                                                    <span class="valueUnit">{{ data.valueUnit }}</span>
                                                </div>
                                                <div class="Percentage_input" v-else-if="data.searchType == 'moq'">
                                                    <input class="input" type="number" placeholder="0" min="0" v-model="inputBoxes[data.id].inputValue1" @click.stop />
                                                    <span> ~ </span>
                                                    <input class="input" type="number" placeholder="4000" min="0" v-model="inputBoxes[data.id].inputValue2" @click.stop />
                                                    <span class="valueUnit">{{ data.valueUnit }}</span>
                                                </div>
                                                <div class="Percentage_input" v-else>
                                                    <input class="input" type="number" placeholder="0" min="0" v-model="inputBoxes[data.id].inputValue1" @click.stop />
                                                    <span> ~ </span>
                                                    <input class="input" type="number" placeholder="100" min="0" v-model="inputBoxes[data.id].inputValue2" @click.stop />
                                                    <span class="valueUnit">{{ data.valueUnit }}</span>
                                                </div>
                                                <el-button class="Percentage_button" @click="applyChanges(data,data.id, $event)">应用</el-button>
                                            </div>
                                        </div>
                                    </el-tree>
                                </template>

                                <template v-if="datalang == 'English'">
                                    <i class="el-icon-close" @click="close"></i>
                                    <el-tree class="my-tree" :data="searchChildren" show-checkbox default-expand-all node-key="id" :check-strictly="true"
                                        :ref="'treess_'+ index + '_' + index2" highlight-current :props="searchDefaultPropsEn" :filter-node-method="filterNode"
                                        check-on-click-node :expand-on-click-node="true" @check-change="checkChange" @check="currentChecked" @node-click="handleNodeClick">
                                        <div class="custom-tree-node" slot-scope="{ node,data }">
                                            <div class="node_box">
                                                <img v-if="data.searchImage" :src="data.searchImage" alt="" class="node_img">
                                                <span>{{ node.label }}</span>
                                            </div>
                                            <div v-if="data.valueFlag == 1 && isChecked(data.id) && !data.children.length" class="Percentage_box">
                                                <div class="Percentage_input" v-if="data.searchType == 'theWeight' || data.searchType == 'theWidth'">
                                                    <input class="input" type="number" placeholder="0" min="0" v-model="inputBoxes[data.id].inputValue1" @click.stop />
                                                    <span> ~ </span>
                                                    <input class="input" type="number" placeholder="300" min="0" v-model="inputBoxes[data.id].inputValue2" @click.stop />
                                                    <span class="valueUnit">{{ data.valueUnitEn }}</span>
                                                </div>
                                                <div class="Percentage_input" v-else-if="data.searchType == 'moq'">
                                                    <input class="input" type="number" placeholder="0" min="0" v-model="inputBoxes[data.id].inputValue1" @click.stop />
                                                    <span> ~ </span>
                                                    <input class="input" type="number" placeholder="4000" min="0" v-model="inputBoxes[data.id].inputValue2" @click.stop />
                                                    <span class="valueUnit">{{ data.valueUnitEn }}</span>
                                                </div>
                                                <div class="Percentage_input" v-else>
                                                    <input class="input" type="number" placeholder="0" min="0" v-model="inputBoxes[data.id].inputValue1" @click.stop />
                                                    <span> ~ </span>
                                                    <input class="input" type="number" placeholder="100" min="0" v-model="inputBoxes[data.id].inputValue2" @click.stop />
                                                    <span class="valueUnit">{{ data.valueUnitEn }}</span>
                                                </div>
                                                <el-button class="Percentage_button" @click="applyChanges(data,data.id, $event)">APPLY</el-button>
                                            </div>
                                        </div>
                                    </el-tree>
                                </template>
                            </div>
                        </div>
                    </div>
                </ul>

            </div>
            <div class="right" ref="rightHeight" @click="hideVisible">
                <div v-if="dialogFormVisible == true || dialogSearchVisible == true" class="mask"></div>
                <!-- 标签部分先注释掉 -->
                <!-- <div class="tags" ref="tags">
                    <p v-if="datalang == '中文简体' && allTagList.length > 0">全部结果 > "<span
                            v-for="(item, index) in showTagsList" :key="index"> {{
                                item.tagName }} <span class="item-line">- </span></span>"</p>
                    <p v-if="datalang == 'English' && allTagList.length > 0">{{ $t('ActualResult') }} > "<span
                            v-for="(item, index) in showTagsList" :key="index"> {{ item.tagNameEn }} <span
                                class="item-line">- </span></span>"</p>
                    
                    <div class="screen-box" v-if="datalang == '中文简体' && allTagList.length>0">
                        <div class="screen" v-if="showMore == false" @click="toggleShowMore">
                            展示筛选 <img src="../../../assets/images/show.png" alt="">
                        </div>
                        <div class="screen-close" v-if="showMore == true" @click="toggleShowMore">
                            收起筛选 <img src="../../../assets/images/close.png" alt="">
                        </div>
                    </div>
                    <div class="screen-box" v-if="datalang == 'English' && allTagList.length>0">
                        <div class="screen" v-if="showMore == false" @click="toggleShowMore">
                            Show Screening <img src="../../../assets/images/show.png" alt="">
                        </div>
                        <div class="screen-close" v-if="showMore == true" @click="toggleShowMore">
                            Hide Screening <img src="../../../assets/images/close.png" alt="">
                        </div>
                    </div>

                    <div v-if="datalang == '中文简体' && allTagList.length>0 " :class="showMore == true ? 'intact':'portion'">
                        <div class="allTagList" v-for="(item, index) in allTagList" :key="index">
                            <div class="tag-title">{{ item.tagGroupName }}</div>
                            <div :class="item.expanded ? 'tag-all-close' : 'tag-all-show'" ref='tagall'>
                                <el-radio-group v-model="selectedOptions[index]" v-for="(item2, index2) in item.tags" :key="index2"
                                    @click.prevent.native="getTagName(item, index, item2, index2, $event)">
                                    <el-radio :class="selectedItems[index] && selectedItems[index].tagName === item2.tagName? 'selected':''" :label="item2.tagName">{{ item2.tagName }}</el-radio>
                                </el-radio-group>
                            </div>
                            <div v-if="isMultiline[index]" @click="toggleExpand(index)" :class="item.expanded ? 'tagsbtn-show' : 'tagsbtn-close'">
                                {{ item.expanded ? '收起' : '更多' }}
                            </div>
                        </div>
                    </div>
                    
                    <div v-if="datalang == 'English' && allTagList.length>0 " :class="showMore == true ? 'intact':'portion'">
                        <div class="allTagList" v-for="(item, index) in allTagList" :key="index">
                            <span class="tag-title">{{ item.tagGroupNameEn }}</span>
                            <div :class="item.expanded ? 'tag-all-close' : 'tag-all-show'" ref='tagall'>
                                <el-radio-group v-model="selectedOptions[index]" v-for="(item2, index2) in item.tags" :key="index2"
                                    @click.prevent.native="getTagName(item, index, item2, index2, $event)">
                                    <el-radio :class="selectedItems[index] && selectedItems[index].tagNameEn === item2.tagNameEn? 'selected':''" :label="item2.tagName">{{ item2.tagNameEn }}</el-radio>
                                </el-radio-group>
                            </div>
                            <div v-if="isMultiline[index]" @click="toggleExpand(index)" :class="item.expanded ? 'tagsbtn-show' : 'tagsbtn-close'">
                                {{ item.expanded ? 'Retract' : 'More' }}
                            </div>
                        </div>
                    </div>
                </div> -->


                <!-- 选中的列表项展示 -->
                <div class="showItem" v-if="isShowListItem">
                    <div class="showItem_box">
                        <div v-for="(item,index) in checkedNodeItems.selection" :key="item.id" class="showItem_item" @click="closeItem(item)">
                            {{ datalang == '中文简体' ? item.categoryName : item.categoryNameEn}}
                            <i class="el-icon-close"></i>
                        </div>
                        <div v-for="(item,index) in checkedNodeItems.search" :key="item.id" class="showItem_item" @click="closeItem(item)">
                            {{ datalang == '中文简体' ? item.searchName : item.searchNameEn }} 
                            <span v-if="item.valueFlag == 1">{{ item.searchValueGte }}<span>-</span>{{ item.searchValueLte }}</span>
                            <i class="el-icon-close"></i>
                        </div>
                    </div>
                    <div class="clear_all" @click="clearAll">
                        <i class="el-icon-refresh"></i>
                        <span>{{ $t('navbar.clearAll') }}</span>
                    </div>
                </div>


                <ul class="dialog-ul2" v-loading="loading2" :element-loading-text="$t('navbar.Loadingzhong')">
                    <div class="nodata" v-if="this.length < 1">
                        <span v-show="!loading">{{ $t('navbar.NoData') }}!</span>
                        <span v-show="loading"></span>
                    </div>
                    <div v-else v-for="(item, index) in comList.rows" :key="index" class="dialog-ul2-div">
                        <!-- 使用骨架屏 -->
                        <el-skeleton class="el-skeleton" animated :loading="loading">
                            <template slot="template">
                                <el-skeleton-item variant="image" class="sk-img" />
                                <!-- <div style="padding:10px 14px 0 14px;">
                                    <el-skeleton-item variant="p" style="width: 100%" />
                                </div> -->
                                <div style="padding:10px 14px 0 14px;">
                                    <el-skeleton-item variant="p" style="width: 100%" />
                                </div>
                                <div style="padding:10px 14px 0 14px;">
                                    <el-skeleton-item variant="p" style="width: 100%" />
                                </div>
                                <div style="padding:10px 14px 0 14px;">
                                    <el-skeleton-item variant="p" style="width: 100%;height: 25px;" />
                                </div>
                                <div style="padding:10px 14px 0 14px;">
                                    <el-skeleton-item variant="p" style="width: 100%" />
                                </div>
                            </template>
                            <template>
                                <!-- 搜索的时候  (数据不规整只能由前端进行各种判断)-->
                                <div @click="gotodetail(item.id)" v-if="searchObj.keyWord">
                                    <img :src="item.thumbnail" alt="" class="img">
                                    <!-- <p class="skeleton-p card">
                                        -
                                        <span class="card_one"></span>
                                        <span class="card_two"></span>
                                        <span class="card_three"></span>
                                        <span class="card_four"></span>
                                    </p> -->
                                    <p class="skeleton-p productId">{{ datalang == '中文简体' ? '编号：' :'' }}<span v-html="item.productId && item.productId.trim() ? item.productId : '-'"></span></p>
                                    <p class="skeleton-p commodityName"><span v-html="item.commodityName && item.commodityName.trim() ? item.commodityName : '-'"></span></p>
                                    <el-tooltip v-if="datalang == '中文简体'" class="item" effect="light" :content="item.theContentCn && item.theContentCn.trim() ? item.theContentCn : '-'" placement="top">
                                        <p class="skeleton-p content">
                                            <span v-html="item.theContentCn && item.theContentCn.trim() ? item.theContentCn : '-'"></span>
                                        </p>
                                    </el-tooltip>
                                    <el-tooltip v-if="datalang == 'English'" class="item" effect="light" :content="item.theContent && item.theContent.trim() ? item.theContent : '-'" placement="top">
                                        <p class="skeleton-p content">
                                            <span v-html="item.theContent && item.theContent.trim() ? item.theContent : '-'"></span>
                                        </p>
                                    </el-tooltip>
                                    <p class="skeleton-p theWeight">{{ item.theWeight && item.theWeight.trim() ? item.theWeight : '-' }}</p>
                                </div>

                                <!-- 不搜索的时候 -->
                                <div @click="gotodetail(item.id)" v-else>
                                    <img :src="item.commodityImage" alt="" class="img">
                                    <!-- <p class="skeleton-p card">
                                        -
                                        <span class="card_one"></span>
                                        <span class="card_two"></span>
                                        <span class="card_three"></span>
                                        <span class="card_four"></span>
                                    </p> -->
                                    <p class="skeleton-p productId">{{ datalang == '中文简体' ? '编号：' :'' }}{{ item.productId && item.productId.trim() ? item.productId : '-' }}</p>
                                    <p class="skeleton-p commodityName">{{ item.commodityName && item.commodityName.trim() ? item.commodityName : '-' }}</p>
                                    <el-tooltip v-if="datalang == '中文简体'" class="item" effect="light" :content="item.theContentCn && item.theContentCn.trim() ? item.theContentCn : '-'" placement="top">
                                        <p class="skeleton-p content">
                                            <span v-html="item.theContentCn && item.theContentCn.trim() ? item.theContentCn : '-'"></span>
                                        </p>
                                    </el-tooltip>
                                    <el-tooltip v-if="datalang == 'English'" class="item" effect="light" :content="item.theContent && item.theContent.trim() ? item.theContent : '-'" placement="top">
                                        <p class="skeleton-p content">
                                            <span v-html="item.theContent && item.theContent.trim() ? item.theContent : '-'"></span>
                                        </p>
                                    </el-tooltip>
                                    <p class="skeleton-p theWeight">{{ item.theWeight && item.theWeight.trim() ? item.theWeight : '-' }}</p>
                                </div>
                            </template>
                        </el-skeleton>

                        <!-- 不使用骨架屏 -->
                        <!-- <div class="img-name" @click="gotodetail(item.id)">
                            <img :src="item.smallImage" alt="" class="img">
                            <el-tooltip class="item" effect="light" :content="item.commodityName + ' ' + item.productId"
                                placement="top">
                                <span>{{ item.commodityName }} {{ item.productId }}</span>
                            </el-tooltip>
                        </div> -->
                    </div>
                </ul>
                <div class="page">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :page-size="this.idsObj.pageSize"
                        :current-page="searchObj.keyWord ? this.searchObj.page : this.idsObj.current"
                        layout="total, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <PcFooter></PcFooter>
    </div>
</template>

<script>
import { fabricList, commodityList, searchKeyWord, allTagListApi, selectedTagListApi, searchConditionInfo } from "../../../api/index";
import PcHeader from "../../../components/pc/Header.vue"
import PcFooter from "../../../components/pc/Footer.vue"
export default {
    components: {
        PcHeader,
        PcFooter
    },
    data() {
        return {
            selectionList:[],   //选品分类列表
            searchConditionList:[],   //搜索条件列表
            searchActive:null,
            searchIndex:0,
            activeGroup: null,
            activeIndex: null,
            dialogSearchVisible: false,
            isSearchChange: null,
            searchDefaultProps: {
                children: 'children',
                label: 'searchName',
                disabled: function (data, node) {//带子级的节点不能选中
                    if (data.children && data.children.length > 0) {
                        return true
                    } else {
                        return false
                    }
                }
            },
            searchDefaultPropsEn: {
                children: 'children',
                label: 'searchNameEn',
                disabled: function (data, node) {//带子级的节点不能选中
                    if (data.children && data.children.length > 0) {
                        return true
                    } else {
                        return false
                    }
                }
            },
            searchChildren: [],
            isShowPercentage: false,  //是否显示百分比
            checkedNodeIds: {           //存放两个表的选中的id集合
                selection:[],
                search:[]
            },
            checkedNodeItems: {       // 存放两个表的选中的item集合
                selection:[],
                search:[]
            }, 
            clickedNodeId: null,
            inputBoxes: {},
            idsObj: {
                current: 1,     //当前第几页
                pageSize: 14,
                ids: '',          //选品中心  字符串
                searchInfo:[],
                tagList: []
            },
            isShowListItem:false,   //是否显示勾选的列表项弹框
            selectedNodes:[],       //存放已勾选的节点
            lastSelectionIndex: 0,  //存放选品分类列表最后一项的下标
            lastIndex: 0,           //存放搜索条件列表最后一组的下标
            lastInnerIndex: 0,      //存放搜索条件列表最后一组的最后一项的下标



            selectedOptions: [],
            selectedItems: [],
            showTagsList: [],
            tagName: '',//搜索结果
            allTagList: [], //所有标签列表
            loading: true,
            loading2: true,
            list: [],
            active: null,
            dialogFormVisible: false,
            dialogFormVisible2: false,
            modal: false,
            index: 0,
            index2: 0,
            id: '',
            idss: '1',        //默认面料 categoryId
            filterText: '',
            defaultProps: {
                children: 'children',
                label: 'categoryName'
            },
            defaultPropsEn: {
                children: 'children',
                label: 'categoryNameEn'
            },
            comList: [],  //通过传入id获取选中的商品列表
            total: 0,       //总条数
            pageSize: 0,    //每页多少条
            length: 0,
            // pager: 0,
            isChange:0,
            // ids: [],
            // idsObj: {
            //     current: 1,     //当前第几页
            //     ids: null,          //列表选择商品 传入的商品ID  默认进入页面展示的数据
            //     pageSize: 18,
            //     tagList: []
            // },
            msg: '',
            searchObj: {
                keyWord: '',
                page: 1,
                pageSize: 14
            },
            rightHeight: 1035,     //右侧盒子高度
            isRefresh: false,
            datalang: '',   //路由语言判断
            tkboxheight: 1035,
            showMore: false,
            isMultiline: [],
            allTagLister: [], //所有标签列表副本
        }
    },
    // 自定义指令 实现可拖动
    directives: {
        drag(el, bindings) {
            el.onmousedown = function (e) {
                var disx = e.pageX - el.offsetLeft
                var disy = e.pageY - el.offsetTop
                document.onmousemove = function (e) {
                    el.style.left = e.pageX - disx + 'px'
                    el.style.top = e.pageY - disy + 'px'
                }
                document.onmouseup = function () {
                    document.onmousemove = document.onmouseup = null
                }
            }
        }
    },
    watch: {
        //借助计算属性同时监听多条属性  控制搜索列表的弹框
        changeData(newVal, oldVal) {
            // console.log('new',newVal, oldVal)
            if(newVal.activeGroup != oldVal.activeGroup && newVal.activeGroup != null){
                this.dialogSearchVisible = true
            }
        },


        // dialogSearchVisible(newVal) {
        //     console.log('newVal',newVal)
        //     if (!newVal) {
        //         // this.checkedNodeIds = [];     //弹框取消时显示百分比的盒子隐藏
        //         this.inputBoxes = {};         //弹框取消时填百分比的输入框也重置
        //     }
        // },
        filterText(val) {
            this.$refs.tree.filter(val);
        },
        $route(to, from) {
            if (to.path !== '') {
                this.dialogFormVisible = false
            }
            if (to.path == '/selection') {
                this.$EventBus.$on("msg", (data) => {
                    this.msg = data;
                    // console.log("$EventBus", this.msg)
                    this.searchObj.page = 1       //页数重置
                    this.idsObj.current = 1        //页数重置
                    this.getsearchKeyWord(this.searchObj)
                    if (!this.searchObj.keyWord) {
                        var page = this.searchObj.page
                        this.$EventBus.$emit("page", page);
                    } else {
                        var pages = this.searchObj.page + 1   //让搜索框搜索的商品列表在第一页也能刷新页面
                        this.$EventBus.$emit("pages", pages);
                    }
                });
            }
        },
        isRefresh() {
            this.$EventBus.$on("isRefresh", (isRefresh) => {
                this.isRefresh = isRefresh
                if (this.isRefresh == true) {
                    this.active = null
                    this.idsObj.current = 1        //页数重置
                    this.idsObj.ids = 1
                    this.idsObj.tagList = []
                    this.showTagsList = []
                    this.selectedOptions = []
                    this.selectedItems = []
                    // this.refreshTree()
                    this.dialogFormVisible = false
                    this.getcommodityList(this.idsObj)
                    // this.getSelectedTagList(this.idsObj.ids)
                }
            })
        }
    },
    computed: {
        changeData(){
            const { activeGroup,activeIndex } = this
            return { activeGroup,activeIndex }
        },
    },
    methods: {
        // 一键清空
        clearAll(){
            // 清空弹框勾选
            this.checkedNodeIds.selection = []
            this.checkedNodeIds.search = []
            // 清空显示的listItem
            this.checkedNodeItems.selection = []
            this.checkedNodeItems.search = []
            // 清空应用的范围值
            this.inputBoxes = {}
            // 隐藏放置listItem的盒子
            this.isShowListItem = false
            // 刷新数据
            this.idsObj.current = 1        //页数重置
            this.idsObj.ids = 1
            this.idsObj.searchInfo = [],
            this.idsObj.tagList = []
            this.getcommodityList(this.idsObj)
        },
        //点击右侧隐藏弹框
        hideVisible(){
            this.dialogFormVisible = false
            this.dialogSearchVisible = false
        },
        checkMultiline() {
            this.isMultiline = []
            setTimeout(() => {
                const textElement = this.$refs.tagall;
                // console.log('dayin---',textElement)
                if(textElement){
                    textElement.forEach((item,index)=>{
                        // console.log('item',item)
                        if (item instanceof HTMLElement) {  // 确保 item 是 DOM 元素
                            if(item.offsetHeight + 5 < item.scrollHeight){
                                this.isMultiline.push(true);
                            }else{
                                this.isMultiline.push(false);
                            }
                        }
                    })
                    // console.log('sdsdsds',this.isMultiline)
                }
            }, 700);
        },
        toggleShowMore() {
            this.showMore =!this.showMore;
        },
        toggleExpand(index){
            this.$set(this.allTagList[index], 'expanded',!this.allTagList[index].expanded);
        },
        refreshTree() {
            // console.log('清空操作在这？？')
            if (this.active) {
                this.$refs.tree[this.index2].setCheckedKeys([]);
            }
        },
        //处理全部结果 
        getTagName(item, index, item2, index2, event) {
            // console.log(item, index, item2, index2, event)
            if (!this.selectedItems[index]) {
                this.selectedItems[index] = {
                    id: '',
                    tagName: '',
                    tagNameEn: ''
                }
            }

            //取消选中
            // console.log('event', event.target.innerText);
            // console.log('selectedItems', this.selectedItems);
            if (this.selectedItems[index].tagName === event.target.innerText || this.selectedItems[index].tagNameEn === event.target.innerText) {
                // 如果是，则取消选中状态
                this.selectedItems[index].id = '';
                this.selectedItems[index].tagName = '';
                this.selectedItems[index].tagNameEn = '';
            } else {
                item.tags.forEach((item) => {
                    if (event.target.innerText == item.tagName || event.target.innerText == item.tagNameEn) {
                        this.selectedItems[index].id = item.id;
                        this.selectedItems[index].tagName = item.tagName;
                        this.selectedItems[index].tagNameEn = item.tagNameEn;
                    }
                })
            }
            let newArr = this.selectedItems.filter(function (item, index) {
                return item.id !== null && item.id !== '';
            })
            this.showTagsList = JSON.parse(JSON.stringify(newArr))
            this.idsObj.tagList = newArr.map(item => parseInt(item.id));
            this.getcommodityList(this.idsObj)
        },

        // 获取搜索条件列表
        async getSearchConditionList() {
            let { data: res } = await searchConditionInfo()
            // console.log('获取搜索条件列表',res)
            if(res.result){
                this.searchConditionList = res.result
                this.lastIndex = this.searchConditionList.length - 1;
                this.lastInnerIndex = this.searchConditionList[this.lastIndex].children.length - 1;
            }
        },



        //根据id获取分类下绑定的标签
        // async getSelectedTagList(id) {
        //     let { data: res } = await selectedTagListApi(id)
        //     if(res && res.result){
        //         this.allTagList = res.result
        //         this.allTagLister = res.result
        //     }
        //     this.checkMultiline()
        // },
        close() {
            this.dialogFormVisible = false
            this.dialogSearchVisible = false
        },
        //重复点击li取消弹框    点击二级列表渲染所有商品（需分页处理）
        isChoose(index, item) {
            if (index != this.isChange) {
                this.isChange = index;
                this.dialogFormVisible = true
            }
        },
        //li和右侧内容对应起来
        changeIndex(index) {
            this.index2 = index
        },
        // 选品分类列表的change事件
        changeActive(index, item) {
            this.active = index;
            this.index = index
            // console.log(index, item)
            // 点击选品分类列表时将搜索条件列表的状态置空
            this.activeGroup = null
            this.activeIndex = null
            this.dialogSearchVisible = false

            if(this.checkedNodeIds.selection){
                // setTimeout(() => {
                    this.$nextTick(() => {
                        this.$refs.tree[this.lastSelectionIndex].setCheckedKeys(this.checkedNodeIds.selection);
                    })
                // }, 200);
            }

            // this.idsObj.ids = item.id
            // this.getcommodityList(this.idsObj)
            // this.getSelectedTagList(this.idsObj.ids)
            // this.idss = item.id
        },
        // 条件列表的change事件
        changeSearchActive(groupIndex, itemIndex,item2) {
            this.activeGroup = groupIndex;
            this.activeIndex = itemIndex;
            // console.log(groupIndex,itemIndex,item2)
            this.searchChildren = item2.children
            // console.log('this.searchChildren',this.searchChildren)
            // 点击搜索条件列表时将选品分类列表的状态置空
            this.index = null
            this.active = null
            this.dialogFormVisible = false

            // console.log('需要回显得',this.checkedNodeIds.search)
            this.$nextTick(()=>{
                if(this.checkedNodeIds.search){
                    const treeRef = this.$refs[`treess_${this.lastIndex }_${this.lastInnerIndex }`][0];
                    if (treeRef) {
                        treeRef.setCheckedKeys(this.checkedNodeIds.search);
                    }
                }
            })

            // this.idsObj.ids = item2.id
            // this.getcommodityList(this.idsObj)
            // this.getSelectedTagList(this.idsObj.ids)
            // this.idss = item2.id
        },
        // 匹配搜索条件列表中点击的那一项
        isActive(groupIndex, itemIndex) {
            return groupIndex === this.activeGroup && itemIndex === this.activeIndex;
        },
        //li和右侧内容对应起来  (组也要对应上)
        changeSearchIndex(groupIndex, itemIndex) {
            if(groupIndex == this.activeGroup){
                this.activeIndex = itemIndex
                this.dialogSearchVisible = !this.dialogSearchVisible
            }
        },
        // 搜索条件列表重复点击li取消弹框
        isSearchChoose(index2,item2){
            if (index2 != this.isSearchChange) {
                this.isSearchChange = index2;
                this.dialogSearchVisible = true
            }
        },

        async getfabricList() {
            //调取所有选品列表的接口  获取面料库及选品中心列表
            let { data: res } = await fabricList();
            // console.log('res.result', res.result)
            if(res.result){
                res.result.forEach((item) => {
                    if (item.id == 1) {
                        this.selectionList.push(item)
                    }
                    if (item.id == 107) {
                        this.selectionList.push(item)
                    }
                })
                this.lastSelectionIndex = this.selectionList.length - 1;
            }
        },
        gotodetail(id) {
            // this.$router.push({ path: `/detail/${commodityId}` })
            this.$router.push({ path: `/detail/${id}` })
        },

        getCheckedNodes() {
            // console.log(this.$refs.tree.getCheckedNodes());
        },
        getCheckedKeys() {
            // console.log(this.$refs.tree.getCheckedKeys());
        },
        //输入关键字进行过滤
        filterNode(value, list) {
            if (!value) return true;
            return list.categoryName.indexOf(value) !== -1;
        },

        checkChange(data, checked, indeterminate) {
            if (checked) {
                if(data.categoryName){
                    // 检查 this.checkedNodeIds.selection 中是否已存在 data.id
                    if (!this.checkedNodeIds.selection.includes(data.id)) {
                        this.checkedNodeIds.selection.push(data.id);
                    }
                    // 检查 this.checkedNodeItems.selection 中是否已存在相同 id 的对象
                    const isDuplicateInItemsSelection = this.checkedNodeItems.selection.some(item => item.id === data.id);
                    if (!isDuplicateInItemsSelection) {
                        this.checkedNodeItems.selection.push(data);
                    }
                } else if(data.searchName){
                    // 检查 this.checkedNodeIds.search 中是否已存在 data.id
                    if (!this.checkedNodeIds.search.includes(data.id)) {
                        this.checkedNodeIds.search.push(data.id);
                    }
                    // 检查 this.checkedNodeItems.search 中是否已存在相同 id 的对象
                    const isDuplicateInItemsSearch = this.checkedNodeItems.search.some(item => item.id === data.id);
                    if (!isDuplicateInItemsSearch) {
                        this.checkedNodeItems.search.push(data);
                        // 当勾选时，检查是否需要显示弹框并处理
                        if (data.valueFlag === 1 &&!data.children.length) {
                            if (!this.inputBoxes[data.id]) {
                                this.inputBoxes[data.id] = {
                                    inputValue1: null,
                                    inputValue2: null
                                };
                            }
                        }
                    }
                }


                // if(data.categoryName){
                //     this.checkedNodeIds.selection.push(data.id);
                //     this.checkedNodeItems.selection.push(data)
                // }else if(data.searchName){
                //     this.checkedNodeIds.search.push(data.id);
                //     this.checkedNodeItems.search.push(data)
                //     // 当勾选时，检查是否需要显示弹框并处理
                //     if (data.valueFlag === 1 &&!data.children.length) {
                //         if (!this.inputBoxes[data.id]) {
                //             this.inputBoxes[data.id] = {
                //                 inputValue1: 0,
                //                 inputValue2: 100
                //             };
                //         }
                //     }
                // }
                
            } else {
                // 当取消勾选时的逻辑      this.checkedNodeIds拆分成两个数组，因为上下两个表对应勾选的id有可能重复
                let targetArray;
                if(data.categoryName){
                    targetArray = this.checkedNodeIds.selection;
                }else if(data.searchName){
                    targetArray = this.checkedNodeIds.search;
                }
                const index = targetArray.findIndex(id => id === data.id);
                if (index > -1) {
                    targetArray.splice(index, 1);
                    // 当取消勾选时，将对应节点的输入框数据置空
                    delete this.inputBoxes[data.id];
                }


                // 处理 checkedNodeItems 数据
                let itemArray;
                if(data.categoryName){
                    itemArray = this.checkedNodeItems.selection
                }else if(data.searchName){
                    itemArray = this.checkedNodeItems.search
                }
                const itemIndex = itemArray.findIndex(item => item.id === data.id);
                if (itemIndex > -1) {
                    itemArray.splice(itemIndex, 1);
                }

                // const index = this.checkedNodeIds.findIndex(id => id === data.id);
                // if (index > -1) {
                //     this.checkedNodeIds.splice(index, 1);
                //     // 当取消勾选时，将对应节点的输入框数据置空
                //     delete this.inputBoxes[data.id];
                // }
            }
            // console.log('===============',this.checkedNodeIds)
        },
        isChecked(nodeId) {
            return this.checkedNodeIds.search.includes(nodeId);
        },
        handleNodeClick(node) {
            this.clickedNodeId = node.id;
            if (!this.inputBoxes[this.clickedNodeId]) {
                this.inputBoxes[this.clickedNodeId] = {
                inputValue1: null,
                inputValue2: null
                };
            }
        },
        applyChanges(node,nodeId, event) {
            event.stopPropagation();
            this.idsObj.searchInfo.forEach(item=>{
                if(item.searchId == nodeId){
                    if(node.searchType=='theWeight' || node.searchType=='theWidth'){
                        item.searchValueGte = parseInt(this.inputBoxes[nodeId].inputValue1) || 0;
                        item.searchValueLte = parseInt(this.inputBoxes[nodeId].inputValue2) || 300;
                    }else if(node.searchType=='moq'){
                        item.searchValueGte = parseInt(this.inputBoxes[nodeId].inputValue1) || 0;
                        item.searchValueLte = parseInt(this.inputBoxes[nodeId].inputValue2) || 4000;
                    }else{
                        item.searchValueGte = parseInt(this.inputBoxes[nodeId].inputValue1) || 0;
                        item.searchValueLte = parseInt(this.inputBoxes[nodeId].inputValue2) || 100;
                    }
                }
            })

            // 查找并更新 nodeId 对应的对象中的属性
            let targetNode = this.checkedNodeItems.search.find(item => item.id === nodeId);
            if (targetNode && targetNode.valueFlag === 1) {
                if(targetNode.searchType=='theWeight' || targetNode.searchType=='theWidth'){
                    targetNode.searchValueGte = parseInt(this.inputBoxes[nodeId].inputValue1) || 0;
                    targetNode.searchValueLte = parseInt(this.inputBoxes[nodeId].inputValue2) || 300;
                }else if(targetNode.searchType=='moq'){
                    targetNode.searchValueGte = parseInt(this.inputBoxes[nodeId].inputValue1) || 0;
                    targetNode.searchValueLte = parseInt(this.inputBoxes[nodeId].inputValue2) || 4000;
                }else{
                    targetNode.searchValueGte = parseInt(this.inputBoxes[nodeId].inputValue1) || 0;
                    targetNode.searchValueLte = parseInt(this.inputBoxes[nodeId].inputValue2) || 100;
                }
            }

            // console.log('更新后的需要传递给后端的searchInfo',this.idsObj.searchInfo)
            this.getcommodityList(this.idsObj)
            // console.log('更新后的this.checkedNodeItems',this.checkedNodeItems)
        },

        // 叉掉上面展示的勾选的列表项
        closeItem(item){
            // console.log('叉掉上面展示的勾选的列表项',item)
            if(item.searchName){
                this.checkedNodeItems.search = this.checkedNodeItems.search.filter(currentItem => currentItem!== item);
                this.checkedNodeIds.search = this.checkedNodeIds.search.filter(currentItem => currentItem!== item.id);
                // 叉掉后将其对应的输入框也重置
                if(item.valueFlag === 1){
                    this.inputBoxes[item.id] = {
                        inputValue1: null,
                        inputValue2: null
                    };
                }
            }else if(item.categoryName){
                this.checkedNodeItems.selection = this.checkedNodeItems.selection.filter(currentItem => currentItem!== item);
                this.checkedNodeIds.selection = this.checkedNodeIds.selection.filter(currentItem => currentItem!== item.id);
            }
            // console.log('叉掉后的数据checkedNodeItems',this.checkedNodeItems)
            // console.log('叉掉后的数据checkedNodeIds',this.checkedNodeIds)
            this.idsObj.ids = this.checkedNodeIds.selection.toString() || 1
            this.idsObj.searchInfo = this.idsObj.searchInfo.filter(item => {
                return this.checkedNodeIds.search.includes(item.searchId);
            });
            // console.log('this.idsObj',this.idsObj)
            if(this.idsObj.ids == 1 && this.idsObj.searchInfo.length == 0){
                this.isShowListItem = false
            }
            this.idsObj.current = 1        //页数重置
            this.getcommodityList(this.idsObj)
        },




        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        async getsearchKeyWord() {
            this.searchObj.keyWord = this.msg

            const res = await searchKeyWord(this.searchObj);
            // console.log(res)
            this.comList.rows = res.data.result.rows
            // console.log("comList======", this.comList)
            this.total = res.data.result.totalCount * 1
            this.searchObj.page = res.data.result.page * 1
            this.length = res.data.result.rows.length
        },
        handleCurrentChange(page) {
            // console.log(`当前页: ${page}`);

            if (this.msg) {
                this.searchObj.page = page
                // console.log(this.searchObj.page)
                this.getsearchKeyWord(this.searchObj)
                var pages = page + 1   //让搜索框搜索的商品列表在第一页也能刷新页面
                this.$EventBus.$emit("pages", pages);
            } else {
                this.idsObj.current = page
                this.getcommodityList(this.idsObj)
                this.$EventBus.$emit("page", page);
            }
            // this.$EventBus.$emit("page", page);
        },


        //tree  选中节点的相关操作
        currentChecked(nodeObj, SelectedObj) {
            // console.log('nodeObj',nodeObj) 
            // console.log('SelectedObj',SelectedObj)
            // console.log(SelectedObj.checkedKeys)   // 这是选中的节点的key数组
            // console.log(SelectedObj.checkedNodes)  // 这是选中的节点数组 

            // console.log('看看存放勾选对象的集合',this.checkedNodeItems)  
            const searchArr = this.checkedNodeItems.search
            const selectionArr = this.checkedNodeItems.selection.map(item => item.id)
            // console.log('searchArr',searchArr)
            // console.log('selectionArr',selectionArr)

            // var arr = SelectedObj.checkedKeys
            if(this.checkedNodeItems.selection.length > 0 || this.checkedNodeItems.search.length > 0){
                this.isShowListItem = true
            }else{
                this.isShowListItem = false
            }

            if(selectionArr.length > 0){
                this.idsObj.ids = selectionArr.toString()
            }else{
                this.idsObj.ids = this.idss
            }

            if (searchArr.length > 0) {
                searchArr.forEach(node => {
                    if (node.valueFlag === 1) {
                        if (!this.idsObj.searchInfo.some(item => item.searchId === node.id)) {
                            if(node.searchType=='theWeight' || node.searchType=='theWidth'){
                                this.idsObj.searchInfo.push({
                                    searchId: node.id,
                                    searchValueGte: 0,
                                    searchValueLte: 300,
                                });
                                node.searchValueGte = 0,
                                node.searchValueLte = 300
                            }else if(node.searchType=='moq'){
                                this.idsObj.searchInfo.push({
                                    searchId: node.id,
                                    searchValueGte: 0,
                                    searchValueLte: 4000,
                                });
                                node.searchValueGte = 0,
                                node.searchValueLte = 4000
                            }else{
                                this.idsObj.searchInfo.push({
                                    searchId: node.id,
                                    searchValueGte: 0,
                                    searchValueLte: 100,
                                });
                                node.searchValueGte = 0,
                                node.searchValueLte = 100
                            }
                        }
                    } else if (node.valueFlag === 0) {
                        if (!this.idsObj.searchInfo.some(item => item.searchId === node.id)) {
                            this.idsObj.searchInfo.push({ searchId: node.id });
                        }
                    }
                });

                const checkedNodeIds = searchArr.map(node => node.id);
                this.idsObj.searchInfo = this.idsObj.searchInfo.filter(item => checkedNodeIds.includes(item.searchId));
            }else{
                this.idsObj.searchInfo = []
            }
            // console.log('搜索列表最终获取的结果', this.idsObj.searchInfo);


            this.idsObj.current = 1        //页数重置
            this.searchObj.page = 1       //页数重置 
            this.getcommodityList(this.idsObj)
            // this.getSelectedTagList(this.idsObj.ids)
        },
        //通过id调用商品   及分页设置
        async getcommodityList(idsObj) {
            this.msg = ''
            this.searchObj.keyWord = ''
            let { data: res } = await commodityList(idsObj);
            // console.log('通过id调用商品   及分页设置', res.result)
            if (res.result == null) {
                console.log("请勾选商品！")
                return
            } else {
                this.comList = res.result
                this.length = res.result.rows.length
                this.total = this.comList.totalCount * 1
                this.idsObj.current = this.comList.page * 1
                // this.pager = Math.floor((this.comList.total - 1) / 10) + 1
            }
            this.loading = true
            this.loading2 = false
            setTimeout(() => (this.loading = false), 500)
        }
    },
    //页面初始化加载商品
    created() {
        this.idsObj.ids = 1
        this.getcommodityList(this.idsObj)
        // this.getSelectedTagList(this.idsObj.ids)

        this.$EventBus.$on('this.languageValue', (data) => {
            this.datalang = data
        })
        this.toggleShowMore()
    },
    mounted() {
        this.getfabricList()
        this.getSearchConditionList()

        this.allTagList.forEach(item => {
            item.expanded = false;
        });

        this.$EventBus.$on("msg", (data) => {
            this.msg = data;
            this.searchObj.page = 1       //页数重置
            this.idsObj.current = 1        //页数重置
            this.getsearchKeyWord(this.searchObj)
            if (!this.searchObj.keyWord) {
                var page = this.searchObj.page
                this.$EventBus.$emit("page", page);
            } else {
                var pages = this.searchObj.page + 1   //让搜索框搜索的商品列表在第一页也能刷新页面
                this.$EventBus.$emit("pages", pages);
            }
        });
        // window.onresize = () => {
        //     return (() => {
        //         this.rightHeight = this.$refs.rightHeight.offsetHeight
        //         // console.log(this.rightHeight)
        //     })()
        // };
        this.$EventBus.$on("isRefresh", (isRefresh) => {
            this.isRefresh = isRefresh
        })

        this.checkMultiline()

        this.isMultiline.forEach(item => {
            item.isTagShow = false;
        });

        this.showMore = false
        // setTimeout(() => {
        //     this.showMore = false
        //     this.allTagList = this.allTagList.slice(0, 3);
        // },800)
    },
    beforeDestroy() {
        //移除监听事件"page"
        this.$EventBus.$off("page")
        this.$EventBus.$off("pages")
        this.$EventBus.$off("isRefresh")
    },
    // fliters: {
    //     capitalize(value) {
    //         let newVal = parseFloat(value).toFixed(2)
    //         return newVal
    //     }
    // }
}
</script>

<style lang="scss" scoped>
* {
    margin: 0;
    padding: 0;
}

/deep/em {
    color: red;
    font-style: normal;
}

/deep/.el-tree-node__label {
    font-size: 18px;
    // padding: 18px 0;
}

/deep/.el-tree-node__content {
    min-height: 31px;
    height: auto !important;
    margin: 3px 0;
    background-color: #ffffff;
    // display: flex;
    // align-items: flex-start;
}
/deep/.el-tree-node__content:hover {
    // height: 31px;
    margin: 3px 0;
    background-color: #ffffff;
}

.el-input {
    margin: 16px 0;
}

// 选中每一项的样式
/deep/ .el-tree-node.is-current>.el-tree-node__content {
    // background: rgba(24, 24, 24, 0.2);
    // color: #FF235A;
    background-color: #ffffff;
    // margin-bottom: 100px;
}
/deep/ .el-tree-node.is-current:hover {
    // color: #FF235A;
    background-color: #ffffff;
}

/deep/ .el-tree-node.is-current {
    border-radius: 4px;
}

.el-tree {
    margin: 24px 0;
    // background-color: #F4F4F4;
}

/deep/.el-tree {
    .el-checkbox__inner,
    span.el-checkbox__inner {
        // 未选中的 checkbox 样式
        width: 18px;
        height: 18px;
        border-radius: 5px;
    }

    .is-checked .el-checkbox__inner,
    .is-checked span.el-checkbox__inner {
        // 选中的 checkbox 样式
        background-color: #FF235A;
        border: none;
        width: 18px;
        height: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
    }

    // 勾选框中白色对勾的位置
    .el-checkbox__inner::after {
        top: 4px;
        left: 8px;
    }

    .is-indeterminate .el-checkbox__inner {
        // 半选中的 checkbox 样式
        background-color: #FF235A;
        width: 16px;
        height: 16px;
        border: none;
    }
}

/deep/.el-dialog.is-fullscreen {
    background-color: #F4F4F4;
}

/deep/.el-tree .is-indeterminate .el-checkbox__inner {
    width: 18px;
    height: 18px;
    border-radius: 5px;
}

/deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
    top: 6px;
}

.el-pagination {
    // width: 100%;
    // text-align: center;
}

.mlk-box {
    width: 100%;
    // font-family: Simas;

    .mlk-box-inner {
        margin: auto;
        display: flex;
        min-height: 1000px;

        .right {
            min-height: 1000px;
            // height: 1200px;
            // overflow-y: scroll;
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 1;
            flex-wrap: wrap;
            // flex-direction: column;
            position: relative;
            // padding-bottom: 92px;
            // background: yellowgreen;

            .mask{
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.2);
                display: block;
                z-index: 9998;
            }
            .tags {
                margin: 20px 15px 0 15px;
                font-size: 18px;
                width: 100%;

                p {
                    margin-bottom: 15px;

                    span:nth-last-child(1) {
                        .item-line {
                            display: none;
                        }
                    }
                }

                .screen-box{
                    width: 98%;
                    height: 40px;
                    line-height: 40px;
                    display: flex;
                    justify-content: end;
                    align-items: center;
                    .screen,.screen-close{
                        font-family: Source Han Sans;
                        font-size: 16px;
                        font-weight: normal;
                        line-height: 20px;
                        letter-spacing: 0em;
                        font-variation-settings: "opsz" auto;
                        font-feature-settings: "kern" on;
                        color: rgba(0, 0, 0, 0.85);
                        border: 1px solid #c7c7c7;
                        border-radius: 5px;
                        padding: 5px 15px;
                        cursor: pointer;
                        -webkit-user-select: none;  /* 针对 Safari 和 Chrome  */
                        -moz-user-select: none;     /* 针对 Firefox  */
                        -ms-user-select: none;      /* 针对 IE 和 Edge  */
                        user-select: none;          /* 通用的标准属性  */
                        img{
                            width: 14px;
                            margin-left: 10px;
                        }
                    }
                    .screen-close{
                        color: #FF235A;
                        border: 1px solid #FF235A;
                    }
                }

                .intact {
                    // background-color: aqua;
                    min-height: 154px;
                }
                .portion {
                    // background-color: gray;
                    height: 154px;
                    overflow: hidden;
                }

                .allTagList {
                    min-height: 50px;
                    line-height: 50px;
                    // border-top: 1px solid #D8D8D8;
                    display: flex;

                    .tag-title {
                        min-width: 200px;
                        line-height: 50px;
                        background: #F4F4F4;
                        text-align: center;
                    }
                    .tag-all-show{
                        line-height: 50px;
                        width: 82%;
                        height: 50px;
                        overflow: hidden;
                    }
                    .tag-all-close{
                        line-height: 50px;
                        width: 82%;
                    }
                    .tagsbtn-show,.tagsbtn-close{
                        width: 80px;
                        text-align: end;
                        padding: 2px 25px;
                        height: 50px;
                        line-height: 50px;
                        cursor: pointer;
                        -webkit-user-select: none;  /* 针对 Safari 和 Chrome  */
                        -moz-user-select: none;     /* 针对 Firefox  */
                        -ms-user-select: none;      /* 针对 IE 和 Edge  */
                        user-select: none;          /* 通用的标准属性  */
                        background: url(../../../assets/images/show.png) no-repeat;
                        background-position: right 16px;
                        background-size: 20px;
                        // background-color: aqua;
                    }
                    .tagsbtn-show{
                        color: #ec0808;
                        background: url(../../../assets/images/close.png) no-repeat;
                        background-position: right 16px;
                        background-size: 20px;
                    }

                    /deep/.el-radio-group {
                        .el-radio {
                            line-height: 50px;
                            min-width: 140px;
                            text-align: center;
                            cursor: pointer;
                            color: #074787;

                            .el-radio__input {
                                display: none;
                            }

                            .el-radio__label {
                                font-size: 18px;
                            }

                            .selected{
                                color: #ec0808;
                            }
                        }
                    }
                    // .el-radio__input.is-checked + .el-radio__label {
                    //      color: #ec0808 !important;
                    //  }
                    .selected{
                        color: #ec0808 !important;
                    }
                }
                .showbtn-box{
                    display: flex;
                    justify-content: end;
                    width: 98%;
                    .showbtn{
                        padding: 3px 8px;
                        font-size: 16px;
                        background-color: #ffffff;
                        border: 1px solid #b6b6b6;
                        border-radius: 5px;
                        color: #444444;
                        cursor: pointer;
                    }
                }

                .allTagList:nth-last-child(1) {
                    // border-bottom: 1px solid #D8D8D8;
                }
            }

            /deep/.el-dialog {
                background-color: #F4F4F4;
            }

            .img {
                width: 216px;
                height: 216px;
            }


            // 勾选列表展示
            .showItem{
                margin: 10px 10px 0;
                font-size: 16px;
                width: 100%;
                min-height: 50px;
                background: #F2F2F2;
                border-radius: 10px;
                display: flex;

                .showItem_box{
                    width: 90%;
                }
                .clear_all{
                    // width: 100px;
                    height: 30px;
                    line-height: 30px;
                    padding: 0 10px;
                    position: absolute;
                    top: 25px;
                    right: 30px;
                    cursor: pointer;
                    .el-icon-refresh{
                        font-size: 18px;
                        margin-right: 10px;
                    }
                }
                .clear_all:hover{
                    border-radius: 5px;
                    background: rgb(197, 197, 197);
                }
                .showItem_item{
                    background: #fd4573;
                    display: inline-block;
                    padding: 8px 5px 8px 15px;
                    margin: 10px 10px;
                    border-radius: 12px;
                    color: #fff;
                    cursor: pointer;
                    .el-icon-close{
                        margin: 0 5px 0 10px;
                    }
                }
                .showItem_item:hover{
                    background: #ff7194;
                }
            }


            .dialog-ul2 {
                // width: 100%;
                flex: 1;
                display: flex;
                min-height: 900px;
                // height: 100%;
                align-content: start;
                // justify-content:space-between;
                flex-wrap: wrap;
                margin-top: 20px;
                font-size: 16px;
                // min-height:916px;
                // align-items: flex-start;
                // justify-content: center;
                // flex-direction: column;
                // justify-content: flex-start;
                list-style: none;
                // height: 40%;
                // overflow: hidden;
                // position: relative;

                // li {
                //     display: flex;
                // }
                // span{
                //     margin-top:-100px;
                // }
                .nodata {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    min-height: 883px;
                }

                .dialog-ul2-div {
                    width: 14.25%;
                    display: flex;
                    justify-content: center;
                    margin: 0 0 20px 0;

                    // height:400px;
                    .el-skeleton {
                        // box-sizing: border-box;
                        width: 216px;
                        margin: 10px 6px;
                        height: 378px;
                        // height: 398px;
                        background: #fff;
                        border-radius: 16px;
                        border: 1px solid #DBE3EB;
                        cursor: pointer;
                        &:hover{
                            border: 1px solid #FF235A;
                            box-shadow: 0px 4px 10px 0px rgba(12, 28, 44, 0.2)
                        }

                        .sk-img {
                            width: 216px;
                            height: 216px;
                            border-radius: 16px;
                        }
                        .img {
                            border-radius: 16px;
                        }
                    }
                    

                    .skeleton-p {
                        // white-space: nowrap;
                        // overflow: hidden;
                        // text-overflow: ellipsis;
                        cursor: pointer;
                        text-align: start;
                        margin: 13px 14px;
                        // font-size: 16px;
                        font-family: Inter, sans-serif;
                    }
                    .card{
                        display: flex;
                        span{
                            display: inline-block;
                            width: 14px;
                            height: 14px;
                            border-radius: 4px;
                            margin-right: 6px;
                        }
                        .card_one{
                            background: #FA5151;
                        }
                        .card_two{
                            background: #8A38F5;
                        }
                        .card_three{
                            background: #07B9B9;
                        }
                        .card_four{
                            background: #FF8F1F;
                        }
                    }
                    .productId{
                        font-size: 13px;
                        color: #788191;
                        font-weight: 600;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .commodityName{
                        font-size: 15px;
                        color: #1C2740;
                        font-weight: 600;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .content{
                        height: 36px;
                        line-height: 18px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        font-size: 13px;
                        color: #1C2740;
                    }
                    .theWeight{
                        font-size: 12px;
                        color: #545F6E;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }

            .page {
                width: 100%;
                text-align: center;
                position: absolute;
                bottom: 10px;
                left: 0;

                /deep/li{
                    border-radius: 4px;
                    box-sizing: border-box;
                    border: 1px solid #D6DFE8;
                    margin: 0 2px;
                }
                /deep/li:hover{
                    color: #FF235A;
                }
                /deep/li.active {
                    color: #fff;
                    // width: 28px;
                    // height: 28px;
                    border-radius: 4px;
                    background: #FF235A;
                    box-sizing: border-box;
                    border: 1px solid #FF235A;
                    cursor: default;
                }
                /deep/.btn-next:hover{
                    color: #FF235A;
                }
                /deep/.btn-prev:hover{
                    color: #FF235A;
                }
            }
        }
    }
}



::-webkit-scrollbar {
    width: 4px;  /* 调整滚动条的宽度 */
}
::-webkit-scrollbar-track {
    background: #ffffff;  /* 滚动条轨道的背景颜色 */
}
::-webkit-scrollbar-thumb {
    background: #b6b6b6;  /* 滚动条滑块的颜色 */
    border-radius: 5px;
}
::-webkit-scrollbar-thumb:hover {
background: #555;  /* 鼠标悬停在滚动条滑块上时的颜色 */
}

.mlk-box {
    width: 100%;
    // font-family: Simas;

    .mlk-box-inner {
        margin: auto;
        display: flex;
        min-height: 1000px;

        .ul-box {
            user-select:none;     //使文字无法选中无法复制
            width: 300px;
            // height: 100%;
            background-color: #F2F5F8;
            // background: aqua;
            position: relative;
            .ul_top{
                // width: 100%;
                padding: 20px;
                .hr{
                    padding: 10px 0;
                    border-bottom: 1px solid #D6DFE8;
                    margin-bottom: 10px;
                    color: #AAB0BB;
                }
                .fabric_warpActive{
                    width: 107%;
                    background: #FFF;
                }
                .fabric_warp{
                    width: 107%;
                    background: #F2F5F8;
                }
                .fabric_box{
                    display: flex;
                    align-items: center;
                    height: 48px;
                    font-size: 16px;
                    position: relative;
                    cursor: pointer;
                    padding-left: 15px;
                    margin-left: -10px;
                    width: 90%;
                    background-color: #F2F5F8;
                    color: #273344;
                    
                    .fabric_icon{
                        width: 20px;
                        height: 20px;
                    }
                    span{
                        line-height: 28px;
                        margin-left: 20px;
                    }
                    .arrow{
                        width: 16px;
                        height: 16px;
                        position: absolute;
                        right:20px;
                    }
                }
                .active{
                    display: flex;
                    align-items: center;
                    height: 48px;
                    font-size: 16px;
                    position: relative;
                    cursor: pointer;
                    padding-left: 15px;
                    margin-left: -10px;
                    width: 90%;
                    background-color: #FFF;
                    border-radius: 10px 0 0 10px;
                    
                    .fabric_icon{
                        width: 20px;
                        height: 20px;
                    }
                    span{
                        line-height: 28px;
                        margin-left: 20px;
                        color: #FF235A;
                    }
                    .arrow{
                        width: 16px;
                        height: 16px;
                        position: absolute;
                        right:20px;
                        transform: rotate(-90deg);
                    }
                }
                .dialog_children {
                    user-select:none;     //使文字无法选中无法复制
                    position: absolute;
                    top: 0;
                    left: 305px;
                    width: 350px;
                    height: 100%;
                    overflow: auto;
                    background-color: #ffffff;
                    box-sizing: border-box;
                    padding: 5px 10px;
                    cursor: pointer;
                    z-index: 9999;

                    /deep/ .el-tree>.el-tree-node> .el-tree-node__content {
                        font-family: Microsoft YaHei UI;
                        font-size: 14px;
                        font-weight: normal;
                        line-height: 24px;
                        letter-spacing: 0em;
                        font-variation-settings: "opsz" auto;
                        color: #788195;
                        padding: 8px 0;
                        // margin-bottom: 10px;
                        // border-bottom: 1px solid #D6DFE8;
                        // position: relative;
                        .el-checkbox__input {
                            // display: none;
                            cursor: pointer;
                            outline: 0;
                            line-height: 1;
                            vertical-align: middle;
                            position: absolute;
                            left: 295px;
                            top: -10px;
                        }
                    }
                    /deep/ .el-tree>.el-tree-node>.el-tree-node__children>.el-tree-node:first-child{
                        border-top: 1px solid #D6DFE8;
                        padding-top: 10px;
                    }

                    /deep/ .el-tree-node__content>.el-tree-node__expand-icon{
                        display: none;
                    }

                    .el-icon-close {
                        position: absolute;
                        top: 10px;
                        right: 10px;
                        font-size: 20px;
                        width: 20px;
                        height: 20px;
                    }

                    .el-icon-close:hover {
                        color: blue;
                    }
                }
            }
            .ul_search{
                // height: 990px;
                height: 800px;
                padding: 10px 21px;
                overflow: auto;
                .search_list{
                    margin-bottom: 30px;
                }
                .hr{
                    padding: 10px 0;
                    border-bottom: 1px solid #D6DFE8;
                    margin-bottom: 10px;
                    color: #AAB0BB;
                }
                .search_warpActive{
                    width: 107%;
                    background: #fff;
                }
                .search_warp{
                    width: 107%;
                    background: #F2F5F8;
                }
                .search_box{
                    display: flex;
                    align-items: center;
                    height: 48px;
                    font-size: 16px;
                    position: relative;
                    cursor: pointer;
                    padding-left: 15px;
                    margin-left: -10px;
                    width: 90%;
                    background-color: #F2F5F8;
                    color: #273344;
                    
                    .fabric_icon{
                        width: 20px;
                        height: 20px;
                    }
                    span{
                        width: 170px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        line-height: 28px;
                        margin-left: 20px;
                    }
                    .arrow{
                        width: 16px;
                        height: 16px;
                        position: absolute;
                        right:20px;
                    }
                }
                .searchActive{
                    display: flex;
                    align-items: center;
                    height: 48px;
                    font-size: 16px;
                    position: relative;
                    cursor: pointer;
                    background: #ffffff;
                    border-radius: 10px 0 0 10px;
                    padding-left: 15px;
                    margin-left: -10px;
                    width: 90%;
                    
                    .fabric_icon{
                        width: 20px;
                        height: 20px;
                    }
                    span{
                        width: 170px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        line-height: 28px;
                        margin-left: 20px;
                        color: #FF235A;
                    }
                    .arrow{
                        width: 16px;
                        height: 16px;
                        position: absolute;
                        right:20px;
                        transform: rotate(-90deg);
                    }
                }
                .dialog_children {
                    user-select:none;     //使文字无法选中无法复制
                    position: absolute;
                    top: 0;
                    left: 305px;
                    min-width: 350px;
                    height: 100%;
                    overflow: auto;
                    background-color: #ffffff;
                    // box-sizing: border-box;
                    padding: 5px 10px;
                    cursor: pointer;
                    z-index: 9999;

                    /deep/ .el-tree>.el-tree-node> .el-tree-node__content {
                        font-family: Microsoft YaHei UI;
                        font-size: 16px;
                        font-weight: normal;
                        line-height: 24px;
                        letter-spacing: 0em;
                        font-variation-settings: "opsz" auto;
                        color: #788195;
                        padding: 5px 0;
                        // margin-bottom: 10px;
                        // border-bottom: 1px solid #D6DFE8;
                        // position: relative;

                        .el-checkbox__input {
                            // display: none;
                            cursor: pointer;
                            outline: 0;
                            line-height: 1;
                            vertical-align: middle;
                            // position: absolute;
                            // left: 245px;
                            // top: 0;
                            // top: -10px;
                        }
                        
                    }

                    /deep/ .el-tree>.el-tree-node>.el-tree-node__children>.el-tree-node:first-child{
                        border-top: 1px solid #D6DFE8;
                        padding-top: 10px;
                    }

                    /deep/.el-checkbox .is-disabled{
                        display: none;
                    }

                    /deep/.el-tree-node__label {
                        font-size: 18px;
                        padding: 18px 0;
                    }

                    /deep/.el-tree-node__content {
                        min-height: 31px;
                        height: auto !important;
                        margin: 3px 0;
                        background-color: #ffffff;
                        display: flex;
                        align-items: flex-start;
                    }

                    /deep/ .el-tree-node__content>.el-tree-node__expand-icon{
                        font-size: 18px;
                        padding: 2px 0;
                        // display: none;
                        position: absolute;
                        right: 10px;
                    }

                    /deep/.el-icon-caret-right:before{
                        content: "\e6e0";
                        // transform: rotate(90deg);
                    }

                    .el-icon-close {
                        position: absolute;
                        top: 10px;
                        right: 10px;
                        font-size: 20px;
                        width: 20px;
                        height: 20px;
                    }

                    .el-icon-close:hover {
                        color: blue;
                    }
                    .node_box{
                        display: flex;
                        align-items: center;
                    }

                    .node_img{
                        width: 48px;
                        height: 24px;
                        margin: 0 10px 0 12px;
                        border-radius: 4px;
                    }

                    .Percentage_box{
                        width: 13vw;
                        // height: 10vh;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-evenly;
                        padding: 10px 0;
                        margin-left: -20px;
                        .Percentage_input{
                            width: 100%;
                            // height: 30px;
                            // line-height: 1;
                            padding-bottom: 10px;
                            .input{
                                width: 35%;
                                height: 35px;
                                line-height: 1;
                                border: 1px solid #bebebe;
                                border-radius: 5px;
                                text-indent: 1em;
                                font-size: 15px;
                            }
                            .input::placeholder{
                                opacity: 0.5;
                            }
                            .input::-webkit-inner-spin-button,
                            .input::-webkit-outer-spin-button {
                                -webkit-appearance: none;
                                margin: 0; /* 去除可能存在的间距 */
                            }
                            input:focus {
                                outline: none;
                                border: 1px solid #bebebe;
                            }
                            span{
                                margin: 0 2%;
                            }
                            .valueUnit{
                                display: inline-block;
                                width: 40px;
                                text-align: center;
                            }
                        }
                        .Percentage_button{
                            width: 98%;
                            height: 35px;
                            line-height: 35px;
                            font-size: 16px;
                            border: 1px solid #FF235A;
                            border-radius: 5px;
                            background: #fff;
                            color: #FF235A;
                        }
                        .Percentage_button:hover{
                            color: #ff6c91;
                            border: 1px solid #ff6c91;
                        }
                    }
                }
            }
        }
    }
}

</style>